import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  flex-wrap: wrap;
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ShopNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const AffiliateType = styled.div`
  color: ${Colors.GS600};
  font-size: 12px;
  margin-left: 2px;
`

export const DateRange = styled.div`
  color: ${Colors.GS600};
  font-size: 12px;
  white-space: nowrap;
`
